import {
  CHANGE_FRIEND_NOTIFICATION_BADGE_SUCCESS,
  CHANGE_MESSAGE_NOTIFICATION_BADGE_SUCCESS,
} from './types';
import { fetchFriendRequests } from './friendRequestsAction';
import { fetchInboxMessages } from './messageAction';

export const changeNotificationBadge = (notificationType, action) => (dispatch) => {
  switch (notificationType) {
    case 'FRIEND_REQUEST':
      dispatch({
        type: CHANGE_FRIEND_NOTIFICATION_BADGE_SUCCESS,
        payload: action,
      });
      break;
    case 'INBOX_MESSAGE':
      dispatch({
        type: CHANGE_MESSAGE_NOTIFICATION_BADGE_SUCCESS,
        payload: action,
      });
      break;
    default:
      break;
  }
};

export const onNewNotification = (notificationType, currentUserID) => (dispatch) => {
  dispatch(changeNotificationBadge(notificationType, true));
  switch (notificationType) {
    case 'FRIEND_REQUEST':
      dispatch(fetchFriendRequests(currentUserID));
      break;
    case 'INBOX_MESSAGE':
      dispatch(fetchInboxMessages(currentUserID));
      break;
    default:
      break;
  }
};
